import React from 'react'
import { Form } from 'react-bootstrap'

export interface DisclaimerProps {
  style?: React.CSSProperties
}

const Disclaimer: React.FC<DisclaimerProps> = (props) => {
  const { style } = props
  return (
    <Form.Group style={{ paddingTop: '50px', ...style }}>
      <p className="lightGreyText">
        <strong>
          <span style={{ fontWeight: 'bold' }}>Disclaimer</span>
        </strong>{' '}
        <br />
        As per{' '}
        <strong>
          <span style={{ fontWeight: 'bold' }}>clause 6 </span>
        </strong>
        <a
          href="https://www.cmainfo.co.za/Docs/cma-info-terms-conditions.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.cmainfo.co.za/Docs/cma-info-terms-conditions.pdf
        </a>{' '}
        of the agreement, CMA Info CC
        <br />
        has no interest in, nor is it affiliated with the bridging finance
        company, General Finance, in any way.
      </p>
    </Form.Group>
  )
}

export default Disclaimer
